<template>
  <b-modal
    footer-class="removed"
    centered
    size="xl"
    title="اختر معاملةً ..."
    id="process-modal"
    v-model="modal"
  >
    <b-input-group class="w-25 mx-auto mb-2 input-group-merge">
      <b-input-group-prepend is-text>
        <feather-icon icon="SearchIcon" />
      </b-input-group-prepend>
      <b-form-input placeholder="بحث ..." />
    </b-input-group>
    <b-row>
      <b-col v-for="n in 20" :key="n" cols="2">
        <b-card class="text-center p-0 process-card">
          <feather-icon size="60" icon="FileTextIcon"></feather-icon>
          <h5 class="mt-1 font-weight-bold">{{ `إجراء رقم ${n}.pdf` }}</h5>
        </b-card>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
} from "bootstrap-vue";
export default {
  components: {
    BModal,
    BCard,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
  },
  props: {
    value: Boolean,
  },
  computed: {
    modal: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss">
.process-card {
  transition: all 0.2s ease;
  &:hover {
    opacity: 0.9;
    background-color: whitesmoke;
    cursor: pointer;
  }
}
</style>
